import GroupsTable from './GroupsTable'
export default GroupsTable
